import GlobirdSelectorOption from 'data/GlobirdSelectorOption';
import { CALLBACK_DISABLED_MESSAGE } from 'data/constant';
import { useSelector } from 'react-redux';
import { StateCode } from 'data/CustomerPortalTypes';
import { selectCurrentAccount, selectUser } from 'store/userSlice';

const baseMenuOptions: GlobirdSelectorOption<string>[] = [
    { name: "FAQs", value: "faq" },
    { name: "Contact us", value: "assistance" },
    { name: "Self Serve Forms", value: "selfserveform" },
    { name: "Change My Plan", value: "changeplan" },
    { name: "Request a call-back", value: "callback" }
];

export const useSupportMenuOptions = (): GlobirdSelectorOption<string>[] => {
    const callbackDisabled = useSelector(selectUser)?.featureFlags?.callbackDisabled ?? false;
    const currentAccount = useSelector(selectCurrentAccount);
    const hasVicService = currentAccount?.services.some(service => service.state === StateCode.VIC) ?? false;

    return baseMenuOptions
        .filter(option => option.value !== 'changeplan' || hasVicService)
        .map((option) =>
        option.value === 'callback'
            ? {
                ...option,
                disabled: callbackDisabled,
                disabledTooltip: callbackDisabled ? CALLBACK_DISABLED_MESSAGE : undefined
            }
            : option);
};
